var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"easy-loading"},_vm._l((8),function(n){return _c('span',{key:n})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }